<template>
  <div>
    <div class="coverShow" v-show="viseable">
      <div class="container-gj" @click="handleCloseClick">
        <div class="container-gd">
          <div class="header">
            <p>{{ type === 1 ? "规范" : "范例" }}</p>
            <i
              class="fa-solid fa-circle-xmark"
              style="color: #8290a3; cursor: pointer"
              @click="handleCloseClick"
            ></i>
          </div>
          <div v-if="type === 1" class="content">
            <!-- Word模板上传请参考以下格式规范与例题示例，使用“Word导入”功能，将题目内容按照示例进行编辑再上传即可
            格式规范：
            <p>
              1.支持题型：单选、多选、下拉、判断、问答五种基本题型，[单选题/多选题/判断题/下拉题/问答题]
              [答案] [解析] 是固定样式，不能删除。
            </p>
            <p>每道题之间有两个空行</p>
            <p>2.所有符号全部为英文符号。</p>
            <p>
              3.所有题型标号支持1.或1、三种格式，题号仅用于统计试题总数，上传到题库不会显示。
            </p>
            <p>4.所有题型 “ [解析]” 字段非必需，没有可不填。</p>
            <p>5.若题型题目中包含图片，则将图片插入到题目中即可。</p>
            <p>
              6.单选题最少3个选项A,B,C，最多支持10个选项，A-J且按照顺序使用，答案仅支持一个选项。
            </p>
            <p>
              7.多选题最少3个选项A,B,C，最多支持10个选项，A-J且按照顺序使用，答案最少两个选项，用英文的逗号进行分隔。
            </p>
            <p>8.选择题选项号和内容之间用英文的句号进行分隔</p>
            <p>9.答案和选项内不要出现分隔符或空格，选项内容不得超过100字</p>
            <p>
              10.下拉题最少3个选项A,B,C，最多支持10个选项，A-J且按照顺序使用，答案仅支持一个选项。
            </p>
            <p>
              11.填空题仅支持题目中出现括号，用英文的括号来代替题目中的填空处。
            </p>
            <p>
              12.填空题里的多个填空答案要用英文的“|”进行分割，单个答案的同义词用英文的分号进行分割。
            </p>
            <p>13.问答题仅支持录入不连续的正反括号，答案内容不得超过9999字</p>
            <p>
              14.问答题可以包含[关键字]，关键字内容不得超过200字，最多添加10个关键词，多个关键词用英文“;”分隔
            </p> -->
            <p>
              支持题型：单选题、多选题、下拉题、判断题、问答题五种基本题型，[单选题/多选题/判断题/下拉题/问答题]是固定样式，不能删除。
            </p>
            <p>每道题之间有一个空行。</p>
            <p>所有符号全部为英文符号。</p>
            <p>单选题最少3个选项A,B,C，最多支持10个选项，A-J且按照顺序使用</p>
            <p>多选题最少3个选项A,B,C，最多支持10个选项，A-J且按照顺序使用</p>
            <p>选择题选项号和内容之间用英文的句号进行分隔</p>
            <p>下拉题最少3个选项A,B,C，最多支持10个选项，A-J且按照顺序使用</p>
            <p>填空题仅支持题目中出现____，用英文的____来代替题目中的填空处.</p>
            <p>问答题仅支持录入不连续的正反括号</p>
          </div>
          <div v-if="type === 2" class="content">
            <p>1.[单选题]驾驶人有下列哪种违法行为一次记6分</p>
            <p>A.使用其他车辆行驶证</p>
            <p>B.饮酒后驾驶机动车</p>
            <p>C.车速超过规定时速50%以上</p>
            <p>D.违法占用应急车道行驶</p>
            <p>2.[多选题]驾驶人有下列哪种违法行为一次记6分？</p>
            <p>A.使用其他车辆行驶证</p>
            <p>B.饮酒后驾驶机动车</p>
            <p>C.车速超过规定时速50%以上</p>
            <p>D.违法占用应急车道行驶</p>
            <p>3.[下拉题]国际象棋起源于英国吗？</p>
            <p>A.对</p>
            <p>B.错</p>
            <p>4.[填空题]新中国成立日期____年____月____日</p>
            <p>5.[问答题] 变配电室要求做到“五防一通”指的是什么?</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 1, // 1 规范 2 范例
    },
  },
  data() {
    return {
      viseable: false,
    };
  },
  methods: {
    handleCloseClick() {
      this.$emit("close");
    },
  },
  watch: {
    showDialog(newVal) {
      this.viseable = newVal;
    },
  },
};
</script>

<style scoped>
.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 100;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 640px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 100;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.content {
  padding: 20px;
}

.content p {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: Regular;
  text-align: left;
  color: #2b2f36;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExampleDialog/index.vue